module.exports = require("https");


//////////////////
// WEBPACK FOOTER
// external "https"
// module id = 8
// module chunks = 0